import { Box, Button, Tooltip } from "@mui/material";
import {
  AccessTimeRounded,
  ContentCopyRounded,
  DirectionsRounded,
  LocalPhoneRounded,
  LocationOnRounded,
} from "@mui/icons-material";
import CustomText from "../components/CustomText";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

const Location = () => {
  const address =
    "Centro Médico Medam, Calpulalpan-Texcoco 105, Xala, 56270 Texcoco de Mora, Méx.";

  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;

  const phone = "+52 595 957 0961";

  const handleCopy = async () => {
    await navigator.clipboard.writeText(address);
    alert("Dirección copiada correctamente.");
  };

  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    address,
  )}`;

  return (
    <>
      <Helmet>
        <title>Ubicación | Centro Médico MEDAM</title>
        <meta
          name="description"
          content="Encuentra la ubicación del Centro Médico MEDAM en Texcoco, conoce nuestros horarios de atención, teléfono y cómo llegar."
        />
        <meta
          name="keywords"
          content="Centro Médico MEDAM, ubicación MEDAM, hospital Texcoco, médicos Texcoco, consulta médica"
        />
        <meta property="og:title" content="Ubicación | Centro Médico MEDAM" />
        <meta
          property="og:description"
          content="Consulta nuestra dirección, horarios y cómo llegar al Centro Médico MEDAM."
        />
        <meta
          property="og:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png"
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <Box sx={design.BackGroud}>
        {/* TÍTULO */}
        <Box sx={design.Header}>
          <CustomText
            variant="subtitle1"
            color="#333333"
            text="Directorio de Doctores"
            sx={design.Title}
          >
            Donde nos puedes encontrar
          </CustomText>
          <Box sx={design.Line} />
        </Box>
        <Box sx={design.Container}>
          <Box sx={design.LeftSide}>
            <Box>
              <CustomText variant="h5" color="#222" sx={design.ClinicTitle}>
                Centro Médico Medam
              </CustomText>
              {/* DIRECCIÓN */}
              <Box sx={design.InfoRow}>
                <Box sx={design.IconCircle}>
                  <LocationOnRounded sx={design.IconColor} />
                </Box>
                <Box flex={1}>
                  <CustomText
                    variant="caption"
                    color="#777"
                    sx={design.InfoLabel}
                  >
                    Dirección
                  </CustomText>
                  <CustomText variant="body1" color="#333" sx={design.InfoText}>
                    {address}
                  </CustomText>
                  <Box sx={design.AlignCopy}>
                    <Tooltip title="Copiar dirección">
                      <Button
                        startIcon={<ContentCopyRounded />}
                        onClick={handleCopy}
                        sx={design.CopyButton}
                      >
                        Copiar dirección
                      </Button>
                    </Tooltip>
                  </Box>
                </Box>
              </Box>
              {/* TELÉFONO */}
              <Box sx={design.InfoRow}>
                <Box sx={design.IconCircle}>
                  <LocalPhoneRounded sx={design.IconColor} />
                </Box>
                <Box>
                  <CustomText
                    variant="caption"
                    color="#777"
                    sx={design.InfoLabel}
                  >
                    Contacto
                  </CustomText>
                  <CustomText variant="body1" color="#333" sx={design.InfoText}>
                    {phone}
                  </CustomText>
                </Box>
              </Box>
              {/* HORARIOS */}
              <Box sx={design.InfoRow}>
                <Box sx={design.IconCircle}>
                  <AccessTimeRounded sx={design.IconColor} />
                </Box>
                <Box flex={1}>
                  <CustomText
                    variant="caption"
                    color="#777"
                    sx={design.InfoLabel}
                  >
                    Horarios
                  </CustomText>
                  <Box sx={design.ScheduleContainer}>
                    <Box sx={design.ScheduleItem}>
                      <CustomText sx={design.ScheduleDay}>
                        Lunes - Viernes
                      </CustomText>
                      <CustomText sx={design.ScheduleHour}>
                        8:00 AM - 8:00 PM
                      </CustomText>
                    </Box>
                    <Box sx={design.ScheduleDivider} />
                    <Box sx={design.ScheduleItem}>
                      <CustomText sx={design.ScheduleDay}>Sábado</CustomText>
                      <CustomText sx={design.ScheduleHour}>
                        9:00 AM - 2:00 PM
                      </CustomText>
                    </Box>
                    <Box sx={design.ScheduleDivider} />
                    <Box sx={design.ScheduleItem}>
                      <CustomText sx={design.ScheduleDay}>Domingo</CustomText>
                      <CustomText
                        sx={{
                          ...design.ScheduleHour,
                          color: "#E53935",
                        }}
                      >
                        Cerrado
                      </CustomText>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            {/* BOTÓN GOOGLE */}
            <Box sx={design.AlignCopy}>
              <Button
                variant="contained"
                href={googleMapsUrl}
                target="_blank"
                startIcon={<DirectionsRounded />}
                sx={design.GoogleButton}
              >
                Cómo llegar con Google Maps
              </Button>
            </Box>
          </Box>
          {/* MAPA */}
          <Box sx={design.RightSide}>
            <iframe
              title="Mapa Centro Médico Medam"
              src={mapSrc}
              width="100%"
              height="100%"
              style={{
                border: 0,
              }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <Box sx={design.StatusCard}>
              <Box sx={design.StatusDot} />
              <CustomText variant="body2" color="#222" sx={design.StatusText}>
                Abierto ahora
              </CustomText>
            </Box>
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default Location;

const design = {
  BackGroud: {
    backgroundImage:
      "url(https://centromedicomedam.com/IMG/centromedicoMEDAM/background_mini_logos_paquetes_del_centro-medico_MEDAM.png)",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  Header: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    mb: 3,
  },
  Title: {
    fontFamily: "Plus Jakarta Sans",
    fontWeight: 800,
    textAlign: "center",
    fontSize: {
      xs: 30,
      sm: 38,
      md: 48,
      lg: 54,
    },
    lineHeight: "normal",
    marginTop: "-5%",
    marginBottom: "2%",
  },
  Line: {
    width: 90,
    height: 6,
    borderRadius: 99,
    mt: 2,
    background: "linear-gradient(90deg,#00A884,#1976d2)",
  },
  Container: {
    width: {
      xs: "95%",
      sm: "92%",
      md: "88%",
      lg: "85%",
      xl: "78%",
    },
    display: "flex",
    flexDirection: {
      xs: "column",
      lg: "row",
    },
    overflow: "hidden",
    borderRadius: "32px",
    background: "#ffffff",
    boxShadow: "0 25px 60px rgba(0,0,0,.12)",
    mb: 6,
  },
  LeftSide: {
    width: {
      xs: "100%",
      lg: "42%",
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: {
      xs: "28px",
      sm: "34px",
      md: "42px",
    },
  },
  RightSide: {
    position: "relative",
    width: {
      xs: "100%",
      lg: "58%",
    },
    minHeight: {
      xs: 360,
      md: 520,
    },
    background: "#f5f5f5",
  },
  ClinicTitle: {
    fontFamily: "Plus Jakarta Sans",
    fontWeight: 800,
    fontSize: {
      xs: 25,
      md: 30,
    },
    mb: 3,
  },
  InfoRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1,
    mb: 2,
  },
  IconCircle: {
    width: 52,
    height: 52,
    borderRadius: "50%",
    background: "#F4F6F8",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
  },
  InfoLabel: {
    fontFamily: "Plus Jakarta Sans",
    fontWeight: 700,
    fontSize: 10,
    textTransform: "uppercase",
    letterSpacing: 1.1,
    mb: 0.8,
  },
  InfoText: {
    fontFamily: "Plus Jakarta Sans",
    fontWeight: 600,
    fontSize: {
      xs: 12,
      md: 15,
    },
    lineHeight: 1.7,
  },
  CopyButton: {
    textTransform: "none",
    fontFamily: "Plus Jakarta Sans",
    fontWeight: 700,
    color: "#00A884",
    "&:hover": {
      background: "rgba(0,168,132,.08)",
      borderRadius: "8px",
    },
  },
  GoogleButton: {
    width: "50%",
    height: 58,
    borderRadius: "16px",
    textTransform: "none",
    fontFamily: "Plus Jakarta Sans",
    fontWeight: 800,
    fontSize: 13,
    background: "linear-gradient(135deg,#00A884,#00A884)",
    transition: ".35s",
    "&:hover": {
      background: "linear-gradient(135deg,#00906f,#00A884)",
      transform: "translateY(-2px)",
    },
  },
  StatusCard: {
    position: "absolute",
    top: 20,
    right: 20,
    display: "flex",
    alignItems: "center",
    gap: 1,
    background: "rgba(255,255,255,.96)",
    backdropFilter: "blur(8px)",
    padding: "10px 16px",
    borderRadius: "14px",
    boxShadow: "0 12px 25px rgba(0,0,0,.12)",
  },
  StatusDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    background: "#00C853",
    animation: "pulse 1.8s infinite",
  },
  StatusText: {
    fontFamily: "Plus Jakarta Sans",
    fontWeight: 700,
    fontSize: 14,
  },
  IconColor: {
    color: "#00A884",
  },
  AlignCopy: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  ScheduleContainer: {
    display: "flex",
    alignItems: "stretch",
    justifyContent: "space-between",
    gap: 2,
    mt: 1,
    flexDirection: {
      xs: "column",
      md: "row",
    },
  },
  ScheduleItem: {
    flex: 1,
    textAlign: "center",
  },
  ScheduleDivider: {
    width: "1px",
    background: "#E5E7EB",
    display: {
      xs: "none",
      md: "block",
    },
  },
  ScheduleDay: {
    fontFamily: "Plus Jakarta Sans",
    fontWeight: 700,
    fontSize: 15,
    color: "#333",
    mb: 1,
  },
  ScheduleHour: {
    fontFamily: "Plus Jakarta Sans",
    fontWeight: 600,
    fontSize: 14,
    color: "#00A884",
  },
};
